import {
  CLEAR_QUIZ
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
import l from '@/vendor/logger'
import { firebaseBankDb as db } from '@/vendor/firebase'
import { quizBankApiService } from '@/services/api'
// import * as _ from 'ramda'

const state = {
  quizbank: {},
  pause: false,
  inMove: false,
  tmpQuizzes: {}
}

const mutations = {
  [CLEAR_QUIZ] (state) {
    state.quizbank = {}
  },
  tmpQuizzes (state, payload) {
    state.tmpQuizzes = payload
  },
  pause (state, payload) {
    state.pause = payload
  },
  inMove (state, payload) {
    state.inMove = payload
  }
}

const getters = {
  quizDate (state) {
    return state.quizbank.date
      ? state.quizbank.date
      : ''
  },
  quizzes (state) {
    const linkedQuizzes = []
    if (state.inMove) {
      l.d('quizbank/quizzes', 'state.inMove')
      return JSON.parse(state.tmpQuizzes)
    }
    if (!state.quizbank.quizzes) {
      l.d('quizbank/quizzes', 'state.quizbank.quizzes', 'is undefined')
      return []
    }
    l.d('quizbank/quizzes', state.quizbank.quizzes)
    const quizzes = state.quizbank.quizzes
    // let firstQuiz
    let quizIndex = 0
    let customIndex = 0
    let lastQuiz
    for (let quizid in quizzes) {
      const val = quizzes[quizid]
      if (val) {
        if (val.link === undefined || val.link.front === undefined) {
          // firstQuiz = val
          lastQuiz = val
          linkedQuizzes.push(lastQuiz)
        }
      }
    }
    if (lastQuiz && lastQuiz.link) {
      let sssssiba = lastQuiz.link.rear === undefined
      l.d('quizbank/quizzes/lastQuiz', lastQuiz)
      while (!sssssiba) {
        if (lastQuiz.link && lastQuiz.link.rear) {
          lastQuiz = quizzes[lastQuiz.link.rear]
          if (lastQuiz === undefined) {
            sssssiba = true
          } else if (lastQuiz.link === undefined) {
            sssssiba = true
          } else if (lastQuiz.link.rear === undefined) {
            sssssiba = true
          }
          linkedQuizzes.push(lastQuiz)
        }
      }
    }
    l.d('quizbank/quizzes', 'linkedQuizzes', linkedQuizzes)

    return linkedQuizzes.map(quiz => {
      l.d('quizbank/quizzes', 'quiz in linkedQuizzes', quiz)
      if (quiz === undefined) {
        return quiz
      }
      if (quiz.type === 'quiz') {
        quizIndex++
        quiz.index = quizIndex
      } else {
        customIndex++
        quiz.index = customIndex
      }
      return quiz
    })
  }
}

const actions = {
  bindQuiz: firebaseAction(({ bindFirebaseRef, commit }) => {
    bindFirebaseRef('quizbank', db.ref('quiz'))
    // commit('pause', false)
  }),

  unbindQuiz: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('quizbank', db.ref('quiz'))
    db.ref('quiz').off()
    commit([CLEAR_QUIZ])
    // commit('pause', true)
  }),

  async addQuiz ({ state, getters, rootState, commit }, quiz) {
    if (!quiz) { throw new Error('quizbank/addQuiz/no_quiz') }
    if (state.pause) { throw new Error('quizbank/addQuiz/in_action') }
    try {
      commit('pause', true)
      await quizBankApiService({
        method: 'POST',
        token: rootState.userToken,
        body: JSON.stringify(quiz)
      })
      commit('pause', false)
    } catch (err) {
      commit('pause', false)
      l.e('quizbank/addQuiz', err)
    }
  },

  async addQuizX10 ({ state, getters, rootState, commit }, quiz) {
    if (!quiz) { throw new Error('quizbank/addQuiz/no_quiz') }
    if (state.pause) { throw new Error('quizbank/addQuiz/in_action') }
    try {
      commit('pause', true)
      await quizBankApiService({
        method: 'POST',
        token: rootState.userToken,
        body: JSON.stringify(quiz),
        slug: 'ten'
      })
      commit('pause', false)
    } catch (err) {
      commit('pause', false)
      l.e('quizbank/addQuiz/ten', err)
    }
  },

  async modifyQuiz ({ state, getters, rootState, commit }, quiz) {
    if (!quiz) { throw new Error('quizbank/addQuiz/no_quiz') }
    if (state.pause) { throw new Error('quizbank/addQuiz/in_action') }
    try {
      commit('pause', true)
      await quizBankApiService({
        method: 'PUT',
        token: rootState.userToken,
        body: JSON.stringify(quiz),
        slug: quiz.id
      })
      commit('pause', false)
    } catch (err) {
      commit('pause', false)
      l.e('quizbank/modifyQuiz', err)
    }
  },
  async moveQuiz ({ state, getters, rootState, commit }, { quizId, aboveId }) {
    if (!quizId) { throw new Error('quizbank/moveQuiz/no_quizid') }
    if (state.pause) { throw new Error('quizbank/addQuiz/in_action') }
    try {
      commit('pause', true)
      commit('inMove', true)
      commit('tmpQuizzes', JSON.stringify(state.quizbank.quizzes))
      await quizBankApiService({
        method: 'PUT',
        token: rootState.userToken,
        body: JSON.stringify({}),
        slug: `${quizId}/${aboveId}`
      })
      commit('pause', false)
      commit('inMove', false)
    } catch (err) {
      commit('pause', false)
      commit('inMove', false)
      l.e('quizbank/moveQuiz', err)
    }
  },

  async removeQuiz ({ state, getters, rootState, commit }, quizid) {
    if (!quizid) { throw new Error('quizbank/removeQuiz/no_quizid') }
    if (state.pause) { throw new Error('quizbank/addQuiz/in_action') }
    try {
      commit('pause', true)
      await quizBankApiService({
        method: 'DELETE',
        token: rootState.userToken,
        slug: quizid
      })
      commit('pause', false)
    } catch (err) {
      commit('pause', false)
      l.e('quizbank/removeQuiz', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
